import React, { useContext, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home-main.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import {BsTelephone } from "react-icons/bs"
import {GoLocation} from "react-icons/go"
import { amitContext } from "../../context/amit";
import useScrollView from "../userScrollView";

function Home2() {
  const ref = useRef();
  const {current} = useContext(amitContext)
  
  useEffect(() => {
    if(current === 'about' ) {
      ref?.current?.scrollIntoView({behavior: "smooth"})
    }
  }, [current])




  return (
    <Container fluid className="home-about-section" id="about" ref={ref}>
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            Hi Everyone, My name is <span className="purple">Amit Kumar </span>
            I am a passionate <span className="purple">Full Stack Web Developer </span> with skills in the MERN stack, I have learned Full Stack Web Development in <span className="purple">Masai School. </span>Skilled in problem- solving and execution of software tasks from start to finish. I look forward to joining a company where I can contribute to individual and company growth..
            <br /><br/>
            I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />
              
              I apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js</b>
              </i>
            </p>
            <ul>
            <li className="about-activity">
              <MdOutlineEmail fontSize={30}/>:  coolamitgolu567@gmail.com
            </li>
            <li className="about-activity">
              <BsTelephone fontSize={30} />: 7488078433
            </li>
            <li className="about-activity">
              <GoLocation fontSize={30} />: Arrah,Bihar
            </li>
            
          </ul>
          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Amit Kumar</footer>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
